import { instance } from 'utils/api';

// Wire matches the legacy event shape (entity passthrough):
// type is the repeat kind (int), extendedProps a jsonb blob.
export type CalendarEventRow = {
  id: number;
  title?: string | null;
  color?: string | null;
  start?: string | null;
  end?: string | null;
  type: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extendedProps?: Record<string, any> | null;
};

export const fetchCalendarEvents = async (params: {
  start?: Date | string;
  end?: Date | string;
}): Promise<CalendarEventRow[]> => {
  const res = await instance.get<CalendarEventRow[]>('calendar', {
    params: {
      start: params.start ? new Date(params.start).toISOString() : undefined,
      end: params.end ? new Date(params.end).toISOString() : undefined
    }
  });

  return res.data || [];
};

// POST/PUT /calendar — DTO requires color + type(int repeat), optional
// title/start/end/extendedProps(jsonb). Matches the entity + legacy shape.
export type CalendarEventPayload = {
  color: string;
  type: number;
  title?: string;
  start?: string;
  end?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extendedProps?: Record<string, any>;
};

export const createCalendarEvent = async (
  payload: CalendarEventPayload
): Promise<CalendarEventRow> => {
  const res = await instance.post<CalendarEventRow>('calendar', payload);

  return res.data;
};

export const updateCalendarEvent = (
  id: number | string,
  payload: Partial<CalendarEventPayload>
) => instance.put(`calendar/${id}`, payload);

export const deleteCalendarEvent = (id: number | string) =>
  instance.delete(`calendar/${id}`);
